module.exports = __webpack_public_path__ + "static/shahana-2e665f5c06c0aa8056fb3b2fe97bdb0b.jpeg";